module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.9@core-js/library/modules/_fails.js
// module id = ./node_modules/_core-js@2.6.9@core-js/library/modules/_fails.js
// module chunks = 6